module.exports = __webpack_public_path__ + "img/hsbc-logo.2cda19d9.png";